import { setFileversionIdAndNodeOffsetIdMap } from "../actions/common";
import { store } from "../ProviderApp";
import { getAllLeafNodesRecur } from "../components/Viewer/HCViewerUtils";

export function getFileVersionIdAndOffSetByDesignViewerNodeId(nodeId) {
  const state = store.getState();
  const { fileversionIdAndNodeOffsetIdMap } = state;
  let offSet = -1;
  let fileVersionId = null;
  Object.keys(fileversionIdAndNodeOffsetIdMap).forEach((key) => {
    if (fileversionIdAndNodeOffsetIdMap[key] <= nodeId && fileversionIdAndNodeOffsetIdMap[key] > offSet) {
      fileVersionId = key;
      offSet = fileversionIdAndNodeOffsetIdMap[key];
    }
  });
  return { offSet, fileVersionId };
}

export const getFileversionIdFromAwsfilename = (awsFileName) => {
  const state = store.getState();

  const { filesData } = state;
  const fileVersionId = Object.keys(filesData).filter((file) => filesData[file].awsFileName == awsFileName);
  return fileVersionId[0];
};

export const getFileIdFromFileVersionId = (fileVersionId) => {
  const state = store.getState();
  const { filesData } = state;
  return filesData[fileVersionId].fileId;
};

export const getCubeUniqueIdFromNodeId = (nodeId) => {
  const state = store.getState();
  const { nodeIdAndUniqueIdMap } = state;

  const relativeNodeId = nodeId - hwv.model.getNodeIdOffset(nodeId);
  const fileVersionId = getFileversionIdFromAwsfilename(hwv.model.getModelFileNameFromNode(nodeId));

  if (fileVersionId && nodeIdAndUniqueIdMap[fileVersionId]) {
    const fileId = getFileIdFromFileVersionId(fileVersionId);
    const cubeUniqueId = nodeIdAndUniqueIdMap[fileVersionId].nodeIdMap[relativeNodeId];
    if (cubeUniqueId) {
      return `${fileId}_${cubeUniqueId}`;
    }
    return false;
  }
  return false;
};

export const getNodeIdsFromCubeUniqueId = (tempCubeUniqueId, mapper) => {
  if (mapper == undefined) {
    mapper = getFileversionIdAndNodeOffsetIdMap();
  }
  const cubeUniqueId = tempCubeUniqueId.split("_").splice(1).join("_");
  const fileId = tempCubeUniqueId.split("_")[0];

  let nodeIds = [];

  const state = store.getState();
  const { nodeIdAndUniqueIdMap } = state;

  for (const fileVersionId in nodeIdAndUniqueIdMap) {
    const tempFileId = getFileIdFromFileVersionId(fileVersionId);
    if (tempFileId == fileId) {
      nodeIds = nodeIdAndUniqueIdMap[fileVersionId].cubeUniqueIdMap[cubeUniqueId];
      if (Array.isArray(nodeIds) && nodeIds.length) {
        const nodeOffset = mapper[fileVersionId];
        nodeIds = nodeIds.map((node) => node + nodeOffset);
      } else {
        nodeIds = [];
        // TODO: handle eerror case to show to user
      }
    }
  }

  return nodeIds;
};

export const handleModelReset = () => {
  if (viewerImpl.hwv) {
    viewerImpl.hwv.model.reset();
    viewerImpl.hwv.model.setInstanceModifier(
      Communicator.InstanceModifier.DoNotSelect,
      [viewerImpl.hwv.model.getAbsoluteRootNode()],
      false,
    );
    viewerImpl.hwv.model.resetNodesColor([viewerImpl.hwv.model.getAbsoluteRootNode()]);
  }
};

export const getFileversionIdAndNodeOffsetIdMap = (fileVersionId) => {
  const state = store.getState();
  const { fileversionIdAndNodeOffsetIdMap, filesData } = state;

  let fileVersions = [];

  if (filesData[fileVersionId] && filesData[fileVersionId].resourceType == "RESOURCE_TYPE_MERGED_FILE") {
    fileVersions = filesData[fileVersionId].sourceFileVersionId
      .filter((file) => !file.isDeleted)
      .map((file) => file.id);
  } else {
    fileVersions = [fileVersionId];
  }

  if (fileVersions.every((val) => Object.keys(fileversionIdAndNodeOffsetIdMap).includes(val))) {
    return fileversionIdAndNodeOffsetIdMap;
  }

  const mapper = {};

  const absoluteNode = hwv.model.getAbsoluteRootNode();
  const modelFileNodes = hwv.model.getNodeChildren(absoluteNode);

  modelFileNodes.forEach((node) => {
    const awsFilename = hwv.model.getModelFileNameFromNode(node);
    const fileVersionId = getFileversionIdFromAwsfilename(awsFilename);
    if (fileVersionId) {
      const nodeOffset = hwv.model.getNodeIdOffset(node);
      mapper[fileVersionId] = nodeOffset;
    }
  });
  store.dispatch(setFileversionIdAndNodeOffsetIdMap(mapper));
  return mapper;
};

export const modelTransfroms = {
  toJson: () => {
    const modelVsMatrixMap = [];
    const absRootNode = hwv.model.getAbsoluteRootNode();
    const modelNodes = hwv.model.getNodeChildren(absRootNode);
    modelNodes.forEach((modelNode) => {
      const modelTransform = hwv.model.getNodeMatrix(modelNode);
      const fileVersionId = getFileversionIdFromAwsfilename(hwv.model.getModelFileNameFromNode(modelNode));
      modelVsMatrixMap.push([fileVersionId, modelTransform.toJson()]);
    });
    return modelVsMatrixMap;
  },
  fromJson: async (modelVsMatrixMapjson) => {
    modelVsMatrixMapjson.forEach((element) => {
      const fileVersionIdinput = element[0];
      const matrix = Communicator.Matrix.fromJson(element[1]);
      const absRootNode = hwv.model.getAbsoluteRootNode();
      const modelNodes = hwv.model.getNodeChildren(absRootNode);
      modelNodes.forEach((modelNode) => {
        const fileVersionId = getFileversionIdFromAwsfilename(hwv.model.getModelFileNameFromNode(modelNode));
        if (fileVersionIdinput == fileVersionId) {
          hwv.model.setNodeMatrix(modelNode, matrix);
        }
      });
    });
  },
};

export const cubeCuttingData = {
  toJson: () => hwv.cuttingManager.toJson(),
  fromJson: async (cuttingPlaneJson) => await hwv.cuttingManager.fromJson(cuttingPlaneJson),
};

export const cubeCameraData = {
  toJson: () => hwv.view.getCamera().toJson(),
  fromJson: (cameraJson) => hwv.view.setCamera(Communicator.Camera.fromJson(cameraJson), 400),
};

export const cubeColorData = {
  toJson: async () => {
    const colors = [];
    const colorMap = await hwv.model.getNodeColorMap(hwv.model.getAbsoluteRootNode(), Communicator.ElementType.Faces);
    colorMap.forEach((b, a) => {
      const data = getCubeUniqueIdFromNodeId(a);
      if (data) {
        colors.push([data, b.toJson()]);
      }
    });
    return colors;
  },
  // The color from json is getting parsed and activated at view point itself
  fromJson: (colorsJson) => {
    const colorMap = new Map();
    // colorsJson.forEach((val) => {
    //   const nodeIds = getNodeIdsFromCubeUniqueId(val[0])
    //   nodeIds.forEach(node => {
    //     colorMap.set(node, Communicator.Color.fromJson(val[1]));
    //   })
    // });
    colorsJson.forEach((val) => {
      colorMap.set(val[0], Communicator.Color.fromJson(val[1]));
    });
    hwv.model.setNodesColors(colorMap);
  },
};

export const cubeTransparencyData = {
  toJson: () => {
    const state = store.getState();
    const { transparentElements, GetSettingModalData } = state;
    let transparentCubeUniqueIdElements = transparentElements.map((nodeId) => getCubeUniqueIdFromNodeId(nodeId));
    transparentCubeUniqueIdElements = transparentCubeUniqueIdElements.filter((data) => data);

    return {
      elements: transparentCubeUniqueIdElements,
      value: GetSettingModalData.General_transparency,
    };
  },
  fromJson: (data) => {
    hwv.model.setNodesOpacity(data.elements, 1 - data.value);
  },
};

export const cubeVisibilityData = {
  toJson: async () => {
    const visibilityExceptions = [];

    const visibilityData = await hwv.model.getVisibilityState(hwv.model.getAbsoluteRootNode());

    visibilityData.visibilityExceptions.forEach((val) => {
      const cubeUniqueId = getCubeUniqueIdFromNodeId(val);
      if (cubeUniqueId) {
        visibilityExceptions.push(cubeUniqueId);
      }
    });

    const { defaultVisibility } = visibilityData;
    return {
      visibilityExceptions,
      defaultVisibility,
    };
  },

  fromJson: async (defaultVisibility, visibilityExceptions) => {
    await hwv.model.setNodesVisibility([hwv.model.getAbsoluteRootNode()], defaultVisibility);
    await hwv.model.setNodesVisibility(visibilityExceptions, !defaultVisibility);
  },
};

export const cubeMagnitudeData = {
  toJson: () => hwv.explodeManager.getMagnitude(),
  fromJson: async (magnitude) => await hwv.explodeManager.setMagnitude(magnitude),
};

export const cubeFaceVisibility = {
  toJson: () => hwv.view.getFaceVisibility(),
  fromJson: async (faceVisibility) => await hwv.view.setFaceVisibility(faceVisibility),
};

export const cubeSnapshot = {
  toJson: async () => {
    const snapshot = await hwv.takeSnapshot();
    return snapshot.src;
  },
};

export const cubeLineVisibility = {
  toJson: () => hwv.view.getLineVisibility(),
  fromJson: async (lineVisibility) => await hwv.view.setLineVisibility(lineVisibility),
};

export const cubeSheetId = {
  toJson: () => hwv.sheetManager.getActiveSheetId(),
  fromJson: () => {},
};

export const cubeMeasurementsMarkup = {
  toJson: () => hwv.measureManager.exportMarkup(),
  fromJson: async (measurements) => await hwv.measureManager.loadData(measurements),
};

export const cubeMarkup = {
  toJson: () => {
    let markup = [];
    if (hwv.markupManager.getActiveMarkupView()) {
      const markupJson = hwv.markupManager.getActiveMarkupView().toJson();
      markup = markupJson.markup;
    }
    return markup;
  },
  fromJson: async (markupJson) => {
    // In case issues doesnot have a viewpoint
    if (Object.keys(markupJson).length) {
      await hwv.markupManager.loadMarkupData({ views: [markupJson] });
      await hwv.markupManager.activateMarkupView(markupJson.uniqueId);
    }
  },
};

export function handleSelectionLeafNode(selectionsData) {
  const results = [];
  for (let i = 0; i < selectionsData.length; i++) {
    const nodeId = selectionsData[i]._nodeId;
    if (hwv.model.getNodeChildren(nodeId).length) {
      const leafNodes = [];
      getAllLeafNodesRecur(nodeId, leafNodes);
      leafNodes.forEach((node) => {
        const data = getCubeUniqueIdFromNodeId(node);
        const name = viewerImpl.hwv.model.getNodeName(nodeId);
        if (data) {
          results.push({
            ...selectionsData[i].toJson(),
            nodeId: data,
            name,
          });
        }
      });
    } else {
      const data = getCubeUniqueIdFromNodeId(nodeId);
      const name = viewerImpl.hwv.model.getNodeName(nodeId);
      if (data) {
        results.push({
          ...selectionsData[i].toJson(),
          nodeId: data,
          name,
        });
      }
    }
  }
  return results;
}

export const cubeSelectionData = {
  toJson: () => {
    const selectionsData = hwv.selectionManager.getResults();
    return handleSelectionLeafNode(selectionsData);
  },
  fromJson: (selectionJson) => {
    hwv.selectionManager.loadSelectionData(selectionJson);

    // let data = selectionJson;

    // // For backward compatibility
    // if (!Array.isArray(selectionJson)) {
    //   data = Object.keys(selectionJson);
    // }
    // data.forEach((nodeId) => hwv.selectionManager.selectNode(Number(nodeId), 1));
    // return true;
  },
};

export const cubeCurrentShadingData = {
  toJson: () => hwv.view.getDrawMode(),
  fromJson: (mode) => hwv.view.setDrawMode(mode),
};
